
import { Questionnaire } from './questionnaire';
import { Synchro } from './synchro';
import { MediaQuestion } from './media-question';
import { SearchFilters } from './search-filter/search-filters';
import { Statistics } from './statistics';
import { DataNavigationState } from './data-navigation-state';
import {Terminal} from './terminal';

export class ApplicationContext {
    questionnaire:Questionnaire = null;

    statistics:Statistics = null;

    synchros:Synchro[] = null;

    // TODO: this looks redundant. take care of it. We could simply use the above declaration
    synchrosForSearch:Synchro[] = [];

    mediasQuestions:MediaQuestion[] = [];

    dataNavigationState: DataNavigationState;

    searchFilters: SearchFilters;

    constructor(questionnaire:Questionnaire, dataNavigationState: DataNavigationState, searchFilters: SearchFilters) {
        this.questionnaire = questionnaire;
        this.dataNavigationState = dataNavigationState;
        this.searchFilters = searchFilters;
        this.initMediaQuestions();
    }

    setSynchrosAndInitSynchrosForSearch(synchros:Synchro[]) {
        this.synchros = synchros;

        if(this.synchros==null) {
            return;
        }
        for (let i = 0; i < this.synchros.length; i++) {
           const s = this.synchros[i];
           /*const sync = new Synchro();
           sync.id = s.id;
           sync.time = s.time;
           sync.user = s.user;
           sync.device = s.device;*/

            const sync = new Synchro();
            sync.deviceName = s.deviceName;
            sync.deviceId = s.deviceId;
            sync.time = s.time;
            sync.ipAddress = s.ipAddress;
            sync.respondents = s.respondents;
            sync.totalNumberOfRespondents = s.totalNumberOfRespondents;
           this.synchrosForSearch.push(sync);
        }
    }

    initMediaQuestions() {
        for (const question of this.questionnaire.questions) {
            if (question.toSave) {
                if (question.type === 'picture') {
                    this.mediasQuestions.push(new MediaQuestion('pictureQuestion', question.no));
                } else if (question.type === 'gif') {
                    this.mediasQuestions.push(new MediaQuestion('gifs', question.no));
                } else if (question.type === 'photo_bundle') {
                    this.mediasQuestions.push(new MediaQuestion('picturesAnim', question.no));
                } else if (question.type === 'video') {
                    this.mediasQuestions.push(new MediaQuestion('videoQuestion', question.no));
                }
            }
        }
    }
}
